import { BnAction } from '../../common/bn-action';
import { sharedStyles } from '../../styles/shared-styles';
import { css } from '../../utility/lit-entity';

class LocationUndelegateButton extends BnAction {
  constructor() {
    super();
    this.actionname = 'undelegate-partner';
    this.errortext = 'Failed to un-delegate work order location.';
    this.successtext = 'Work Order Location has been undelegated.';
    this.submittext = 'Un-delegate';
    this.suppressheader = true;
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }
}

window.customElements.define('location-undelegate-button', LocationUndelegateButton);
